import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../contexts/AppProvider";
import axios from "axios";
import toast from "react-hot-toast";
import Swal from "sweetalert2";


interface SkillType {
    id?: number,
    title : string;
    description?: string;
    file?: string,
    banner_image?: string | File | null,
}

const API_URL = process.env.REACT_APP_API_URL;

const Dashboard: React.FC = () => {
    const { isLoading, authToken } = useAppContext();
    const navigate = useNavigate();
    const fileRef = React.useRef<HTMLInputElement>(null)
    const [skill, setSkill] = useState<SkillType[]>([])
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [formData, setFormData] = useState<SkillType>({
        title: "",
        description: "",
        file: "",
        banner_image: null
    })

    useEffect ( ()=> {
        if(!authToken){
            navigate("/troypus")
            return
        }
        fetchAllSkill()
    }, [authToken])

    const fetchAllSkill = async () => {
        try {
            const response = await axios.get(`${API_URL}/skill`, {
                headers: {
                    Authorization: `Bearer ${authToken}`           
                },
            });
            console.log(response.data);
            setSkill(response.data.message);
        } catch (error) {
            console.log(error)
        }
    }
    
    const handleOnChangeEvent = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.files){
            setFormData({
                ...formData,
                banner_image: event.target.files[0],
                file: URL.createObjectURL(event.target.files[0]),
            })
        } else {
            setFormData({
                ...formData,
                [event.target.name]: event.target.value
            })
        }
    }

    const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
    
        try {
            const formDataToSend = new FormData();
            if (formData.title) {
                formDataToSend.append("title", formData.title);
            }
            if (formData.description) {
                formDataToSend.append("description", formData.description);
            }
            if (formData.banner_image) {
                formDataToSend.append("banner_image", formData.banner_image);
            }
            if (formData.file) {
                formDataToSend.append("file", formData.file);
            }
    
            if (isEdit){
                formDataToSend.append("_method", "PUT");
                const response = await axios.post(`${API_URL}/skill/${formData.id}`, formDataToSend, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${authToken}`,            
                    },
                });
                if(response.data.status){
                    toast.success("Skill berhasil diperbarui!", {
                        duration: 3000,
                        position: "top-center",
                        style: {
                            background: "#10B981",
                            color: "#fff",
                            padding: "16px"
                        }
                    });
                    setFormData({
                        title: "",
                        description: "",
                        file: "",
                        banner_image: null
                        }
                    )
                    if(fileRef.current){
                        fileRef.current.value = "";
                    }
                }
                setIsEdit(false)
                fetchAllSkill();
            } else {
                const response = await axios.post(`${API_URL}/skill`, formDataToSend, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${authToken}`,            
                    },
                });
                if(response.data.status){
                    toast.success("Skill baru berhasil ditambahkan!", {
                        duration: 3000,
                        position: "top-center",
                        style: {
                            background: "#10B981",
                            color: "#fff",
                            padding: "16px"
                        }
                    });
                    setFormData({
                        title: "",
                        description: "",
                        file: "",
                        banner_image: null
                        }
                    )
                    if(fileRef.current){
                        fileRef.current.value = "";
                    }
                }
                fetchAllSkill();
            }
            } catch (error) {
                console.error(error);
                toast.error("Terjadi kesalahan saat memproses skill", {
                    duration: 3000,
                    position: "top-center",
                    style: {
                        background: "#EF4444",
                        color: "#fff",
                        padding: "16px"
                    }
                });
            }
    };

    const handleEdit = (singleSkill: SkillType) => {
        setFormData({
        id: singleSkill.id,
        title: singleSkill.title,
        description: singleSkill.description,
        });
        setIsEdit(true)
    };

    const handleDelete = (singleSkill: SkillType) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then( async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.delete(`${API_URL}/skill/${singleSkill.id}`,{
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: `Bearer ${authToken}`,            
                        },
                    });
                    if (response.data.status){
                        toast.success(response.data.message)
                        Swal.fire({
                            title: "Deleted!",
                            text: "Your file has been deleted.",
                            icon: "success"
                        });
                        fetchAllSkill();
                    }
                } catch (error) {
                    console.log(error)
                }
            }
        });
    };

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex-col min-h-screen">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

                <div className="bg-white rounded-lg shadow-lg p-6 transition-all duration-300 hover:shadow-xl">
                    <h2 className="text-2xl font-bold text-gray-800 mb-6">{isEdit ? "Edit" : "Add"} Skill</h2>
                    <form onSubmit={handleFormSubmit} className="space-y-4">
                        <div>
                            <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1">Title</label>
                            <input
                                id="title"
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                                name="title"
                                placeholder="Enter skill title"
                                value={formData.title}
                                onChange={handleOnChangeEvent}
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                            <input
                                id="description"
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                                name="description"
                                placeholder="Enter skill description"
                                value={formData.description}
                                onChange={handleOnChangeEvent}
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="bannerInput" className="block text-sm font-medium text-gray-700 mb-1">Banner Image</label>
                            <input
                                id="bannerInput"
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                                type="file"
                                ref={fileRef}
                                onChange={handleOnChangeEvent}
                            />
                            {formData.file && (
                                <div className="mt-2">
                                    <img
                                        src={formData.file}
                                        alt="Preview"
                                        className="w-32 h-32 object-cover rounded-lg shadow-md"
                                    />
                                </div>
                            )}
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200"
                        >
                            {isEdit ? "Update" : "Add"} Skill
                        </button>
                    </form>
                </div>

                <div className="bg-white rounded-lg shadow-lg p-6">
                    <h2 className="text-2xl font-bold text-gray-800 mb-6">Skills List</h2>
                    <div className="overflow-x-auto">
                        {skill && skill.length > 0 ? (
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">#</th>
                                        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Banner</th>
                                        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Title</th>
                                        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Description</th>
                                        <th className="px-4 py-3 text-right text-sm font-semibold text-gray-700">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100">
                                    {skill.map((singleSkill, index) => (
                                        <tr key={index} className="hover:bg-gray-50 transition-colors duration-150">
                                            <td className="px-4 py-3 text-sm text-gray-600">{index + 1}</td>
                                            <td className="px-4 py-3">
                                                {singleSkill.banner_image && typeof singleSkill.banner_image === "string" ? (
                                                    <img
                                                        src={singleSkill.banner_image}
                                                        alt="Banner"
                                                        className="w-12 h-12 rounded-full object-cover border border-gray-200"
                                                    />
                                                ) : (
                                                    <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 text-xs">
                                                        No Image
                                                    </div>
                                                )}
                                            </td>
                                            <td className="px-4 py-3 text-sm font-medium text-gray-900">{singleSkill.title}</td>
                                            <td className="px-4 py-3 text-sm text-gray-600">{singleSkill.description}</td>
                                            <td className="px-4 py-3 text-right space-x-2">
                                                <button
                                                    onClick={() => handleEdit(singleSkill)}
                                                    className="px-3 py-1 bg-yellow-500 text-white rounded-md hover:bg-yellow-600 text-sm transition"
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    onClick={() => handleDelete(singleSkill)}
                                                    className="px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 text-sm transition"
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className="text-center py-8 text-gray-500">
                                No skills found. Add your first skill!
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Dashboard;